import classNames from 'classnames';
import type { CSSProperties } from 'react';
import FJCloseIcon from '../../assets/close.svg?react';
import FJImage from '../../common/components/FJImage/FJImage';
import styles from './FJVideoMetaCard.module.less';

function truncateMiddle(text: string, maxLen: number): string {
    const t = text.trim();
    if (t.length <= maxLen) {
        return t;
    }
    const half = Math.floor((maxLen - 1) / 2);
    return `${t.slice(0, half)}…${t.slice(t.length - half)}`;
}

export interface FJVideoMetaCardProps {
    thumbnailUrl: string;
    title: string;
    /** 有值时展示第二行（如链接），会做截断 */
    sourceUrl?: string;
    /** 有值时展示分辨率角标 */
    resolutionLabel?: string;

    /** 右上角关闭（如返回上一步） */
    onClose?: () => void;
    /** 关闭按钮 accessible 名称 */
    closeLabel?: string;
    /** 标题加粗（设置页等） */
    emphasizeTitle?: boolean;
    /** 自定义样式 */
    style?: CSSProperties;
}

export default function FJVideoMetaCard({
    thumbnailUrl,
    title,
    sourceUrl = '',
    resolutionLabel = '',
    onClose,
    closeLabel = 'Close',
    emphasizeTitle = false,
    style,
}: FJVideoMetaCardProps) {
    const src = thumbnailUrl.trim();
    const urlLine = sourceUrl.trim();
    const resLine = resolutionLabel.trim();

    return (
        <div className={classNames(styles.root, onClose && styles.root_closable)} style={style}>
            {onClose ? (
                <button type='button' className={styles.close_btn} onClick={onClose} aria-label={closeLabel}>
                    <FJCloseIcon className={styles.close_icon} aria-hidden />
                </button>
            ) : null}
            <FJImage
                imgSrc={src}
                boxClassName={styles.thumb_box}
                imgClassName={styles.thumb}
                disableDefaultImgClass
                alt={title}
            />
            <div className={styles.meta}>
                <div className={classNames(styles.title, emphasizeTitle && styles.title_emphasis)}>{title}</div>
                {/* {urlLine ? <div className={styles.subtitle}>{truncateMiddle(urlLine, 56)}</div> : null} */}
                {/* {resLine ? <span className={styles.res_badge}>{resLine}</span> : null} */}
            </div>
        </div>
    );
}
